import React from "react"

import * as styles from "./filter.module.css"
import { testIds } from "../../common/constants"
import { Link } from "gatsby"

import CheckIcon from "../../images/check.svg"

const check = <img src={CheckIcon} className="mr-2" alt="" />

const Filter = ({
  allCategoryTo,
  getCategoryTo,
  categories,
  activeCategory,
}) => (
  <ul className="pl-0 ml-0">
    <div className={styles.wrapper}>
      <li className={`${styles.item} ml-0 mb-5`}>
        <Link
          className={`${styles.link} ${
            activeCategory ? "" : styles.active
          } p-2 mr-4`}
          to={allCategoryTo}
        >
          {!activeCategory && check}
          All
        </Link>
      </li>
      {categories.map(({ title, slug }) => (
        <li key={slug} className={`${styles.item} ml-0 mb-5`}>
          <Link
            className={`${styles.link} ${
              slug === activeCategory?.slug ? styles.active : ""
            } p-2 mr-4`}
            to={getCategoryTo(slug)}
            data-test-id={testIds.components.filter.item}
          >
            {title === activeCategory?.title && check}
            {title}
          </Link>
        </li>
      ))}
    </div>
  </ul>
)

export default Filter
